<template>
    <div :class="{ 'add-box-shadow': addBoxShadow }">
        <h2>Icons</h2>

        <fieldset class="my-6 grid gap-2 border p-4">
            <legend>Controls</legend>
            <label>
                Font Awesome icon string
                <input
                    v-model="iconString"
                    class="my-2 w-full border border-ds-blue-500 p-1 font-mono shadow-[0_0_5px] shadow-ds-blue-500"
                />
            </label>

            <label>
                <input
                    v-model="addBoxShadow"
                    type="checkbox"
                />
                Add box shadow
            </label>
        </fieldset>

        <h3 class="mb-3 mt-4 text-[1rem]">
            Small
            <small class="text-base">(sm / 1rem / 16px)</small>
        </h3>
        <DsIcon
            icon="fas fa-chevron-down"
            size="sm"
        />&nbsp;
        <DsIcon
            icon="far fa-circle-question"
            size="sm"
        />&nbsp;
        <DsIcon
            class="text-ds-red-500"
            icon="fas fa-file-pdf"
            size="sm"
        />&nbsp;
        <DsIcon
            class="border border-ds-blue-500"
            :icon="iconString"
            size="sm"
        />

        <h3 class="mb-3 mt-4 text-[1.5rem]">
            Medium
            <small class="text-base">(md / 1.5rem / 24px)</small>
        </h3>
        <DsIcon
            icon="fas fa-chevron-down"
            size="md"
        />&nbsp;
        <DsIcon
            icon="far fa-circle-question"
            size="md"
        />&nbsp;
        <DsIcon
            class="text-ds-red-500"
            icon="fas fa-file-pdf"
            size="md"
        />&nbsp;
        <DsIcon
            class="border border-ds-blue-500"
            :icon="iconString"
            size="md"
        />

        <h3 class="mb-3 mt-4 text-[2rem]">
            Large
            <small class="text-base">(lg / 2rem / 32px)</small>
        </h3>
        <DsIcon
            icon="fas fa-chevron-down"
            size="lg"
        />&nbsp;
        <DsIcon
            icon="far fa-circle-question"
            size="lg"
        />&nbsp;
        <DsIcon
            class="text-ds-red-500"
            icon="fas fa-file-pdf"
            size="lg"
        />&nbsp;
        <DsIcon
            class="border border-ds-blue-500"
            :icon="iconString"
            size="lg"
        />

        <h3 class="mb-3 mt-4 text-[2.5rem]">
            Extra large
            <small class="text-base">(xl / 2.5rem / 40px)</small>
        </h3>
        <DsIcon
            icon="fas fa-chevron-down"
            size="xl"
        />&nbsp;
        <DsIcon
            icon="far fa-circle-question"
            size="xl"
        />&nbsp;
        <DsIcon
            class="text-ds-red-500"
            icon="fas fa-file-pdf"
            size="xl"
        />&nbsp;
        <DsIcon
            class="border border-ds-blue-500"
            :icon="iconString"
            size="xl"
        />
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import { ref } from 'vue';

const iconString = ref('fa-solid fa-times');
const addBoxShadow = ref(true);
</script>

<style scoped lang="scss">
.add-box-shadow {
    :deep(.ds-icon-frame) {
        box-shadow: 0 0 5px gray;

        &:has(+ h3),
        &:last-child {
            box-shadow: 0 0 5px theme('boxShadowColor.ds.blue.500');
        }
    }
}
</style>
